import { useContext } from 'react';
import { Button, Link, Dialog, DialogBody, DialogFooter, useDisclosure, Text } from '@bitrise/bitkit';
import { format, parseISO } from 'date-fns';
import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { GlobalPropsWithAccount } from '@/models/GlobalProps';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';

const TrialUpdateDialog = () => {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  const { account } = useContext(GlobalPropsContext) as GlobalPropsWithAccount;

  const { mutate } = useMutateUserMetadata({ transform: false });

  if (!account || !account.timeBasedTrial || !account.timeBasedTrial.showUpdatedModal) {
    return null;
  }

  const onDialogClose = () => {
    mutate({ [`time_based_trial_updated_modal_closed_on_${account.slug}`]: true });
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} onClose={onDialogClose} title="Free trial plan update">
      <DialogBody>
        We have recently changed our free trial plan offering. Starting from{' '}
        <strong>{format(parseISO(account.timeBasedTrial.migrationTime || ''), 'MMMM d, yyyy')}</strong>, your free trial
        plan will allow you to explore Bitrise for free for 30 days. Your free trial plan ends on{' '}
        <strong>{format(parseISO(account.timeBasedTrial.endTime || ''), 'MMMM d, yyyy')}</strong>.
        <Text mt="2rem">
          If you are loving having access to all of these features you can continue onto a paid plan or you can continue
          to use the Bitrise Hobby Plan for free if you are not ready to pay and want to proceed with our base tier!
        </Text>
      </DialogBody>
      <DialogFooter>
        <Link
          colorScheme="purple"
          href="https://www.bitrise.io/contact"
          isExternal
          marginInlineStart="16"
          marginInlineEnd="auto"
        >
          Contact us
        </Link>
        <Button as="a" href="https://devcenter.bitrise.io/" target="_blank" variant="secondary">
          Learn more
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default TrialUpdateDialog;
